<h2 class="{{getClass(text | translate)}}">{{ text | translate }}</h2>
